export class KeyValidatorUtil {

    static hasOpenSSHFormat(sshKeyValue: string): boolean {
        // in a well formatted ssh-rsa key 3 different information is contained
        // key type, key payload and comment
        const keyParts = sshKeyValue.trim().split(' ');
        if (keyParts.length < 2) {
            return false;
        }

        // the key type should start with ssh-rsa
        const keyType = keyParts[0];
        if (keyType !== 'ssh-rsa') {
            return false;
        }

        // a valid base64 encoded key string should contain 716 characters
        const keyEncodedData = keyParts[1];
        if (keyEncodedData.length < 700) {
            return false;
        }

        // it should be able to decode correct key payload
        let keyDecodedData = '';
        try {
            keyDecodedData = window.atob(keyEncodedData);
        } catch (e) {
            // not handled, a check wiil be done on keyDecodedData
        }
        if (keyDecodedData.length < 1) {
            return false;
        }

        // correct key-type should be contained in the key payload
        // tslint:disable-next-line:no-bitwise
        const lengthOfTypeFoundInData = (keyDecodedData.charCodeAt(3) & 0xFF);
        const typeFoundInData = keyDecodedData.substring(4, 4 + lengthOfTypeFoundInData);
        if (keyType !== typeFoundInData) {
            return false;
        }

        return true;
    }
}
